module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"today":"Today","filter":"Filter","prev":"Previous","next":"Next","reload":"Reload","day":"Day","week":"Week","month":"Month"},"pt-BR":{"today":"Hoje","filter":"Filtrar","prev":"Anterior","next":"Próximo","reload":"Recarregar","day":"Dia","week":"Semana","month":"Mês"}}')
  delete Component.options._Ctor
}
